import { Layer, Source } from "react-map-gl";
import { Coordinate } from "~/generated/graphql.types";

export const Route = ({
  id,
  route,
  color,
  dotted = false,
}: {
  color: string;
  id: string;
  route: Coordinate[] | null | undefined;
  dotted?: boolean;
}) => {
  return route ? (
    <Source
      id={id}
      type="geojson"
      data={{
        type: "Feature",
        properties: {},
        geometry: {
          coordinates: route.map((coord) => [
            Number(coord.lon),
            Number(coord.lat),
          ]),
          type: "LineString",
        },
      }}
    >
      <Layer
        type="line"
        source={id}
        id={id}
        layout={{
          "line-join": "round",
          "line-cap": "round",
        }}
        paint={{
          "line-color": color,
          "line-width": 5,
          "line-dasharray": dotted ? [0.8, 2] : [1],
        }}
      />
    </Source>
  ) : null;
};
